import React, { useState, useEffect } from "react";
import axios from "axios";
import { API_URL } from "../App.js";
import Footer from "../components/footer";
import { Typography, Card, CardHeader, CardBody, CardFooter } from "@material-tailwind/react";
import { Link } from "react-router-dom";

const Software = () => {
  const [softwareData, setSoftwareData] = useState([]);

  useEffect(() => {
    axios
      .get(`${API_URL}software`)
      .then((response) => {
        const softwareInfo = response.data.data.software;
        setSoftwareData(softwareInfo);
      })
      .catch((error) => {
        console.error("Error fetching software data:", error);
      });
  }, []);

  return (
    <div className="flex flex-col flex-grow bg-gray-50">
      <br />

      <div className="container mx-auto px-4 py-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {softwareData.map((item) => (
            <Link
              key={item.id}
              to={`/softwareID/${item.id}`}
              className="block h-full no-underline"
            >
              <Card className="group hover:shadow-xl transition-all duration-300 hover:-translate-y-1 h-full flex flex-col cursor-pointer">
                <CardHeader className="relative h-48 m-0 overflow-hidden flex-shrink-0">
                  <img
                    src={
                      item.ruta_imagen || process.env.PUBLIC_URL + "/Logo_AdaLab.png"
                    }
                    alt={item.nombre}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  />
                </CardHeader>
                <CardBody className="p-4 flex-grow">
                  <Typography
                    variant="h6"
                    color="blue-gray"
                    className="mb-2 font-sans font-bold"
                  >
                    {item.nombre}
                  </Typography>
                  <Typography className="text-sm font-sans text-gray-600 text-justify">
                    {item.descripcion.length > 150
                      ? `${item.descripcion.slice(0, 150)}...`
                      : item.descripcion}
                  </Typography>
                </CardBody>
                <CardFooter className="pt-0 px-4 pb-4">
                  <button className="w-full bg-[#1a365d] hover:bg-[#2d4a7c] text-white font-sans font-medium py-2.5 px-5 rounded-[25px] transition-all duration-300">
                    Leer más
                  </button>
                </CardFooter>
              </Card>
            </Link>
          ))}
        </div>

        {softwareData.length === 0 && (
          <div className="bg-white rounded-xl shadow-md p-8 text-center">
            <Typography className="text-gray-500 font-sans">
              No hay software disponible en este momento.
            </Typography>
          </div>
        )}
      </div>

      <Footer />
    </div>
  );
};

export default Software;
